// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__MDUVL","heroContent":"Hero_heroContent__InaIc","title":"Hero_title__vS9E_"};